<script lang="ts">
import type { PlaceholderAvatarProps } from '../PlaceholderAvatar.vue'

export type ExchangeAvatarProps = PlaceholderAvatarProps
</script>

<script setup lang="ts">
import placeholder from '../assets/exchange.jpg'
import PlaceholderAvatar from '../PlaceholderAvatar.vue'

const props = withDefaults(defineProps<ExchangeAvatarProps>(), {
  size: 'sm',
})
</script>

<template>
  <PlaceholderAvatar v-bind="props" :placeholder="placeholder" />
</template>
